import { Navigate, useRoutes } from 'react-router-dom';
import React from 'react';

import Dashboard from './layout/Dashboard';
import { isAuthenticated, isStudent, isVerified } from './contexts/AuthContext';
import Entry from './layout/Entry';
import NotFound from './layout/NotFound';
import AssessmentList from './apps/assessment/AssessmentList';
import AssessmentEdit from './apps/assessment/AssessmentEdit';
import AssessmentReview from './apps/assessment/AssessmentReview';
import AssessmentUserReview from './apps/assessment/AssessmentUserReview';
import AssessmentAttempt from './apps/assessment/AssessmentAttempt';
import AssessmentAssignEdit from './apps/assessment/AssessmentAssignEdit';
import AssessmentQuestionEdit from './apps/assessment/AssessmentQuestionEdit';
import Enroll from './apps/enroll/Enroll';
import Invite from './apps/invite/Invite.js';
import Activate from './apps/activate/Activate';
import Profile from './apps/profile/Profile';
import GroupList from './apps/group/GroupList';
import GroupEdit from './apps/group/GroupEdit';
import GroupView from './apps/group/GroupView';
import QAReview from './apps/internal/QAReview';
import InternalDashboard from './layout/InternalDashboard';
import Feedback from './apps/feedback/Feedback';
import FeedbackAction from './apps/internal/FeedbackAction';
import ForgotPassword from './layout/ForgotPassword';
import SetNewPassword from './layout/SetNewPassword';
import EnrolledEdit from './apps/enroll/EnrolledEdit';
import ReferralSignup from './layout/ReferralSignup';
import GenerateQuestions from './apps/internal/GenerateQuestions';
import QAStats from './apps/internal/QAStats';
import Overview from './apps/overview/Overview';
import CompetitionList from './apps/competition/CompetitionList.js';
import CompetitionEdit from './apps/competition/CompetitionEdit.js';
import CompetitionQuestionEdit from './apps/competition/CompetitionQuestionEdit.js';
import CompetitionReview from './apps/competition/CompetitionReview.js';
import CompetitionUserReview from './apps/competition/CompetitionUserReview.js';
import CompetitionAttempt from './apps/competition/CompetitionAttempt.js';
import CompetitionAssignEdit from './apps/competition/CompetitionAssignEdit.js';
import AssessmentAdaptiveAttempt from './apps/assessment/AssessmentAdaptiveAttempt.js';
import Verify from './layout/EntryVerify.js';
import EntryVerify from './layout/EntryVerify.js';
import ActivateUser from './apps/activate/ActivateUser.js';
import Home from './layout/Home.js';
import PrivacyPolicy from './layout/PrivacyPolicy.js';
import TermsAndConditions from './layout/TermsAndConditions.js';

const ProtectedRoute = ({ component: Component }) => {
  /*
  TODO: if user is verified then component else verification page
  */
  if (isAuthenticated()) {
    if (isVerified() || isStudent()) {
      return <Component />
    } else {
      return <Navigate to="/verify" />
    }
  } else {
    return <Navigate to="/login" />
  }

};

/*
export const RouteRoles = {
  '/app/test' : ["parent"],
  '/app/profile': ["teacher"],
}
  */

export default function Router() {
  const routes = useRoutes([
    {
      path: "app",
      element: <ProtectedRoute component={Dashboard} />,
      children: [
        { element: <Navigate to="/app/overview" />, index: true },
        { path: 'practice', element: <AssessmentList /> },
        { path: 'practice/edit/:id', element: <AssessmentEdit /> },
        { path: 'practice/edit/participants/:id', element: <AssessmentAssignEdit /> },
        { path: 'practice/edit/questions/:id', element: <AssessmentQuestionEdit /> },
        { path: 'practice/review/:id', element: <AssessmentReview /> },
        { path: 'practice/review/:id/:userid', element: <AssessmentUserReview /> },
        { path: 'practice/attempt/:id', element: <AssessmentAttempt /> },
        { path: 'practice/adaptive/attempt/:id', element: <AssessmentAdaptiveAttempt /> },
        /*
        { path: 'competition', element: <CompetitionList /> },
        { path: 'competition/edit/:id', element: <CompetitionEdit /> },
        { path: 'competition/edit/questions/:id', element: <CompetitionQuestionEdit /> },
        { path: 'competition/review/:id', element: <CompetitionReview /> },
        { path: 'competition/review/:id/:userid', element: <CompetitionUserReview /> },
        { path: 'competition/attempt/:id', element: <CompetitionAttempt /> },
        { path: 'competition/edit/participants/:id', element: <CompetitionAssignEdit /> },
        */
        { path: 'enroll', element: <Enroll /> },
        { path: 'enroll/edit/:id', element: <EnrolledEdit /> },
        /*
        { path: 'group', element: <GroupList /> },
        { path: 'group/edit/:id', element: <GroupEdit /> },
        { path: 'group/:id', element: <GroupView /> },
        */
        { path: 'invite', element: <Invite /> },
        { path: 'profile', element: <Profile /> },
        { path: 'feedback', element: <Feedback /> },
        { path: 'overview', element: <Overview /> },
        { path: 'activate', element: <Activate/>},
        { path: 'activate/:id', element: <ActivateUser/>}
      ],
    },
    { path: "/", element: <Home/> },
    { path: "", element: <Navigate to="/app" replace /> },
    { path: "/login", element: <Entry /> },
    { path: "/signup", element: <Navigate to="/login?tab=signup" replace /> },
    { path: "/verify", element: <EntryVerify /> },
    { path: "/signup/:id", element: <ReferralSignup /> },
    { path: "/forgotpassword", element: <ForgotPassword /> },
    { path: "/forgotpassword/:id", element: <SetNewPassword /> },
    { path: "/privacy", element: <PrivacyPolicy /> },
    { path: "/tnc", element: <TermsAndConditions /> },
    { path: "*", element: <NotFound /> },
    {
      path: "internal",
      element: <InternalDashboard />,
      children: [
        { element: <Navigate to="/internal/qareview" />, index: true },
        { path: 'qareview', element: <QAReview /> },
        { path: 'feedback', element: <FeedbackAction /> },
        { path: 'generatequestions', element: <GenerateQuestions /> },
        { path: 'qastats', element: <QAStats /> },
      ],
    }
  ]);

  return routes;
}
